export default __webpack_public_path__ + "664ec8e25d573a7a2b95fd87285f29f4.png";